import React from 'react';
import { OFFER_ANCHOR } from '../data/constants';
export function ProblemSection() {
  return <section className="border-b border-steelLine bg-steel px-4 py-8 sm:py-10" data-id="element-123" data-mp="2lstiteg186e0">
      <div className="mx-auto max-w-3xl" data-id="element-124" data-mp="30h7odx4u28y9">
        <h2 className="text-xl text-white sm:text-3xl" data-id="element-125" data-mp="30hzit4mp20my">
          Still Spending Hours <span className="text-gold" data-id="element-126" data-mp="2vq7oqk4bxcs2">Designing Projects From Zero?</span>
        </h2>
        <div className="mt-3 space-y-2 text-sm font-medium leading-snug text-lightGray sm:text-base" data-id="element-127" data-mp="39hmbn21cxy4e">
          <p data-id="element-128" data-mp="35gtxpvhjj51s">
            Every new project means searching for ideas, working out measurements, sketching, adjusting dimensions and
            figuring out where to begin.
          </p>
          <p data-id="element-129" data-mp="3eh8ld1hz8w8g">And before you&apos;ve even touched the metal, you&apos;ve already spent valuable time planning.</p>
          <p className="font-semibold text-white" data-id="element-130" data-mp="1p1iz2z43wxua">
            METAL FABRICATION READY™ gives you thousands of ready-to-build project references so you can skip the blank
            page and get to work faster.
          </p>
        </div>
        <p className="mt-3 border-l-4 border-gold pl-3 font-display text-sm font-extrabold uppercase tracking-wide text-gold sm:text-base" data-id="element-131" data-mp="jeok2j5t64rx">
          Find the project. Check the plan. Prepare. Build.
        </p>
        <a href={OFFER_ANCHOR} className="mt-3 inline-block font-display text-xs font-bold uppercase tracking-wider text-green underline decoration-green/50 underline-offset-4 transition-colors duration-150 ease-out hover:text-greenDeep" data-id="element-132" data-mp="sci9da55ny5l">
          See what&apos;s included →
        </a>
      </div>
    </section>;
}